export default __webpack_public_path__ + "static/media/q7_02.83c41309.jpg";